/**
 * Wraps FileReader in a Promise so it can be awaited and avoid callbacks
 * @param file {File} File or Blob from an input of type file
 * @param reader {FileReader} optional FileReader if you'd like to use your own
 */
export function readFileAsync(file: File | Blob, reader?: FileReader): Promise<string> {
    let _reader = reader || new FileReader();
    return new Promise((resolve, reject) => {
      
      _reader.onload = (e: any) => {
        if (e.target.readyState !== FileReader.DONE) {
          return;
        }
        resolve(_reader.result as string);
      };
  
      _reader.onerror = reject;
  
      _reader.readAsDataURL(file);
    })
  }